import axios from 'axios';
import apiConfig from './ApiConfig';

console.log('Auth API Config:', apiConfig.auth); // 调试信息

/**
 * 认证服务
 * 提供登录、登出和检查登录状态的功能
 */
class AuthService {
  /**
   * 用户登录
   * @param {string} username 用户名
   * @param {string} password 密码
   * @returns {Promise} 登录结果
   */
  async login(username, password) {
    try {
      console.log('Attempting login with:', { username, url: apiConfig.auth.login });

      const response = await axios.post(apiConfig.auth.login, {
        username,
        password
      }, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        withCredentials: true // 启用凭据，与后端CORS配置一致
      });

      console.log('Login response:', response);

      if (response.data.success) {
        // 存储登录状态和用户信息
        localStorage.setItem('isLoggedIn', 'true');
        localStorage.setItem('user', JSON.stringify(response.data.user));
        localStorage.setItem('token', response.data.token);

        // 设置 axios 默认请求头，添加 token
        this.setAuthHeader(response.data.token);
      }

      return response.data;
    } catch (error) {
      console.error('Login error:', error);
      console.error('Error details:', {
        message: error.message,
        response: error.response ? {
          status: error.response.status,
          data: error.response.data
        } : 'No response',
        request: error.request ? 'Request sent but no response' : 'Request not sent'
      });
      throw error;
    }
  }

  /**
   * 设置认证请求头
   * @param {string} token JWT令牌
   */
  setAuthHeader(token) {
    if (token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    } else {
      delete axios.defaults.headers.common['Authorization'];
    }
  }

  /**
   * 检查用户是否已登录
   * @returns {boolean} 是否已登录
   */
  isLoggedIn() {
    return localStorage.getItem('isLoggedIn') === 'true';
  }

  /**
   * 获取当前登录用户信息
   * @returns {Object|null} 用户信息对象，未登录时返回null
   */
  getUser() {
    if (!this.isLoggedIn()) return null;

    try {
      return JSON.parse(localStorage.getItem('user'));
    } catch (e) {
      console.error('Error parsing user data:', e);
      return null;
    }
  }

  /**
   * 获取认证令牌
   * @returns {string|null} JWT令牌，未登录时返回null
   */
  getToken() {
    return localStorage.getItem('token');
  }

  /**
   * 登出
   */
  logout() {
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('user');
    localStorage.removeItem('token');

    // 清除认证请求头
    this.setAuthHeader(null);
  }

  /**
   * 初始化认证状态
   * 在应用启动时调用，恢复之前的登录状态
   */
  initAuth() {
    const token = this.getToken();
    if (token) {
      this.setAuthHeader(token);
    }
  }
}

export default new AuthService();
